import { IDecaDocument } from '@okcargo-apps/shared-domain';
import {
  DecaDocumentFormPayload,
  IDecaLocationSource,
  ISegmentLocationData,
  IStopLocationData,
} from './deca-forms.model';

export function mapFormToDocument(
  formValue: DecaDocumentFormPayload,
  originalDocument: IDecaDocument,
  segmentLocations: ISegmentLocationData[],
  shipperLocation: IStopLocationData | null,
  carrierLocation: IStopLocationData | null,
): IDecaDocument {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { hasSpecialAuthorization, segments: formSegments, changeReason, ...restFormValue } = formValue;

  return {
    ...originalDocument,
    ...restFormValue,
    specialAuthorizationType: hasSpecialAuthorization ? restFormValue.specialAuthorizationType : undefined,
    ...(restFormValue.shipper
      ? {
          shipper: {
            ...originalDocument.shipper,
            ...restFormValue.shipper,
            city: shipperLocation?.city || '',
            postalCode: shipperLocation?.postalCode || '',
            stateCode: shipperLocation?.stateCode || '',
            countryCode: shipperLocation?.countryCode || '',
          },
        }
      : {}),
    ...(restFormValue.carrier
      ? {
          carrier: {
            ...originalDocument.carrier,
            ...restFormValue.carrier,
            city: carrierLocation?.city || '',
            postalCode: carrierLocation?.postalCode || '',
            stateCode: carrierLocation?.stateCode || '',
            countryCode: carrierLocation?.countryCode || '',
          },
        }
      : {}),
    segments: (formSegments || []).map((formSegment, index) => {
      const segmentLocation = segmentLocations[index];
      const originLocation = segmentLocation?.originLocation;
      const destinationLocation = segmentLocation?.destinationLocation;
      const originalSegment = originalDocument.segments?.[index];

      return {
        id: formSegment.id || originalSegment?.id || crypto.randomUUID(),
        goodsDescription: formSegment.goodsDescription ?? '',
        netWeight: formSegment.netWeight ?? undefined,
        origin: {
          ...formSegment.origin,
          date: formSegment.origin.date ? new Date(formSegment.origin.date) : undefined,
          city: originLocation?.city || originalSegment?.origin.city || '',
          postalCode: originLocation?.postalCode || originalSegment?.origin.postalCode || '',
          stateCode: originLocation?.stateCode || originalSegment?.origin.stateCode || '',
          countryCode: originLocation?.countryCode || originalSegment?.origin.countryCode || '',
        },
        destination: {
          ...formSegment.destination,
          date: formSegment.destination.date ? new Date(formSegment.destination.date) : undefined,
          city: destinationLocation?.city || originalSegment?.destination.city || '',
          postalCode: destinationLocation?.postalCode || originalSegment?.destination.postalCode || '',
          stateCode: destinationLocation?.stateCode || originalSegment?.destination.stateCode || '',
          countryCode: destinationLocation?.countryCode || originalSegment?.destination.countryCode || '',
        },
      };
    }),
  };
}

export function mapLocationSourceToStopLocationData(source?: IDecaLocationSource | null): IStopLocationData | null {
  if (!source || (!source.city && !source.postalCode)) {
    return null;
  }

  return {
    city: source.city || '',
    postalCode: source.postalCode || '',
    stateCode: source.stateCode || '',
    countryCode: source.countryCode || '',
  };
}
